module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<div class="xLabelContainer">\n	';
 if(typeof(fieldLabel)!=="undefined"){ 
__p+='\n		<label class="xControlLabel">'+
((__t=( fieldLabel ))==null?'':_.escape(__t))+
'</label>\n	';
 } 
__p+='\n\n	';
 if(typeof(fieldByline)!=="undefined"){ 
__p+='\n		<p class="xControlLabelByline">'+
((__t=( fieldByline ))==null?'':_.escape(__t))+
'</p>\n	';
 } 
__p+='\n</div>\n\n<div class="xFieldContainer">\n\n	';
 if(typeof(displaySelectAll)!=="undefined" && displaySelectAll === true){ 
__p+='\n		<div class="xField xFieldCheckboxChoice xFieldCheckAll">\n			<input type="checkbox" title="Check all options" class="checkField" data-ngx-checkall="'+
((__t=( controlName ))==null?'':_.escape(__t))+
'" autocomplete="off" id="'+
((__t=( controlName ))==null?'':_.escape(__t))+
'_checkall" name="'+
((__t=( controlName ))==null?'':_.escape(__t))+
'_checkall">\n			<label class="xFormLabel xFieldLabel" for="'+
((__t=( controlName ))==null?'':_.escape(__t))+
'_checkall">'+
((__t=( selectAllLabel ))==null?'':_.escape(__t))+
'</label>\n		</div>\n	';
 } 
__p+='\n\n	';
 for(var o=0, n=options.length;o<n;o++){
		var opt = options[o]; 
__p+='\n		<div class="xField xFieldCheckboxChoice ';
 if(opt.imageAssetRef){ 
__p+='hasImage';
 } 
__p+='">\n\n			';
 if(opt.imageAssetRef){ 
__p+='\n				<div class="xMediaContainer xTypeImage">\n					<img src="'+
((__t=( NGX.Util.assetFromRef(opt.imageAssetRef, NGX.context).src ))==null?'':_.escape(__t))+
'">\n				</div>\n			';
 } 
__p+='\n\n			';
 if(opt.embed){ 
__p+='\n				';
 if(opt.embedCode){ 
__p+='\n					<div class="xEmbed">'+
((__t=( opt.embedCode ))==null?'':__t)+
'</div>\n				';
 } 
__p+='\n			';
 } 
__p+='\n\n			<input type="checkbox" title="'+
((__t=( opt.label ))==null?'':_.escape(__t))+
'" class="checkField" data-ngx-filterscope="'+
((__t=( filterScope ))==null?'':_.escape(__t))+
'" ';
 if(userFilter){ 
__p+='data-ngx-progoptin="'+
((__t=( opt.value ))==null?'':__t)+
'"';
 } 
__p+=' name="'+
((__t=( controlName ))==null?'':_.escape(__t))+
'" id="'+
((__t=((isSecondary)?opt.id+'_Secondary': opt.id ))==null?'':_.escape(__t))+
'" value="'+
((__t=( opt.value ))==null?'':_.escape(__t))+
'"\n				   autocomplete="off" ';
 if(opt.selected==="true"){ 
__p+='checked';
 } 
__p+='>\n\n			';
 if(opt.label || opt.description){
__p+='\n				<label class="xFormLabel xFieldLabel" for="'+
((__t=((isSecondary)?opt.id+'_Secondary': opt.id ))==null?'':_.escape(__t))+
'">'+
((__t=( opt.label ))==null?'':__t)+
'\n					';
 if(opt.description){ 
__p+='\n						<p class="xCopy">'+
((__t=( opt.description ))==null?'':__t)+
'</p>\n					';
 } 
__p+='\n				</label>\n			';
 } 
__p+='\n		</div>\n	';
 } 
__p+='\n	';
 if(helpText){ 
__p+='\n	    <div class="xHelpContainer"><p class="xHelpLabel">'+
((__t=( helpText ))==null?'':__t)+
'</p><div role="alert" class="xErrorLabel"></div></div>\n	';
 } 
__p+='\n</div>\n';
}
return __p;
};
